module.exports = {"normal":"","elite":"","boss":"","finalboss":"","rare":""};